import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-events-list',
    templateUrl: './events-list.component.html',
    styleUrls: ['./events-list.component.css'],
    standalone: false
})
export class EventsListComponent {
  @Input() trackingMode: boolean;
}
